$(function () {
	'use strict'
	$(document).ready(function () {
		$('body').addClass('dark-theme');
		$('body').removeClass('light-theme');
		$('body').removeClass('light-leftmenu');
		$('body').removeClass('light-horizontal');
		$('body').removeClass('color-header');
		$('body').removeClass('header-dark');
		$('body').removeClass('color-leftmenu');
		console.log('dsad')
		return false;
	});
	// ______________ SWITCHER-toggle ______________//

	$(document).on("click", '#myonoffswitch51', function () {
		if (this.checked) {
			$('body').addClass('icon-style');
			$('body').removeClass('light-leftmenu');
			$('body').removeClass('dark-leftmenu');
			$('body').removeClass('color-leftmenu');
			$('body').removeClass('light-header');
			$('body').removeClass('color-header');
			$('body').removeClass('header-dark');
			localStorage.setItem("icon-style", "True");
		}
		else {
			$('body').removeClass('icon-style');
			localStorage.setItem("icon-style", "false");
		}
	});

	$(document).on("click", '#myonoffswitch52', function () {
		if (this.checked) {
			$('body').addClass('theme-style');;
			$('body').removeClass('light-leftmenu');
			$('body').removeClass('dark-leftmenu');
			$('body').removeClass('color-leftmenu');
			$('body').removeClass('light-header');
			$('body').removeClass('color-header');
			$('body').removeClass('header-dark');
		}
		else {
			$('body').removeClass('theme-style');
			localStorage.setItem("theme-style", "false");
		}
	});



	$(document).on("click", '#background1', function () {
		$('body').addClass('color-leftmenu');
		$('body').removeClass('light-leftmenu');
		$('body').removeClass('dark-leftmenu');
		return false;
	});

	$(document).on("click", '#background2', function () {
		$('body').addClass('light-leftmenu');
		$('body').removeClass('color-leftmenu');
		$('body').removeClass('dark-leftmenu');
		return false;
	});


	$(document).on("click", '#background3', function () {
		$('body').addClass('header-dark');
		$('body').removeClass('color-header');
		return false;
	});

	$(document).on("click", '#background4', function () {
		$('body').addClass('color-header');
		$('body').removeClass('header-dark');
		return false;
	});

	$(document).on("click", '#background5', function () {
		$('body').addClass('dark-theme');
		$('body').removeClass('light-theme');
		$('body').removeClass('light-leftmenu');
		$('body').removeClass('light-horizontal');
		$('body').removeClass('color-header');
		$('body').removeClass('header-dark');
		$('body').removeClass('color-leftmenu');
		console.log('dsad')
		return false;
	});

	$(document).on("click", '#background6', function () {
		$('body').addClass('light-theme');
		$('body').removeClass('color-header');
		$('body').removeClass('header-dark');
		$('body').removeClass('color-leftmenu');
		$('body').removeClass('dark-theme');
		return false;
	});

	$(document).on("click", '#background7', function () {
		$('body').addClass('color-horizontal');
		$('body').removeClass('light-horizontal');
		$('body').removeClass('header-dark');
		$('body').removeClass('color-header');
		return false;
	});

	$(document).on("click", '#background8', function () {
		$('body').addClass('light-horizontal');
		$('body').removeClass('color-horizontal');
		$('body').removeClass('header-dark');
		$('body').removeClass('color-header');
		return false;
	});


	$("a[data-theme]").click(function () {
		$("head link#theme").attr("href", $(this).data("theme"));
		$(this).toggleClass('active').siblings().removeClass('active');
	});

	/*-- LTR Horizontal Versions --*/
	$(document).on("click", '#myonoffswitch20', function () {
		if (this.checked) {
			$('body').addClass('default-horizontal');
			$('body').removeClass('centerlogo-horizontal');
			localStorage.setItem("default-horizontal", "True");
		} else {
			$('body').removeClass('default-horizontal');
			localStorage.setItem("default-horizontal", "false");
		}
	});
	$(document).on("click", '#myonoffswitch21', function () {
		if (this.checked) {
			$('body').addClass('centerlogo-horizontal');
			$('body').removeClass('default-horizontal');
			localStorage.setItem("centerlogo-horizontal", "True");
		} else {
			$('body').removeClass('centerlogo-horizontal');
			localStorage.setItem("centerlogo-horizontal", "false");
		}
	});
	/*-- width styles ---*/
	$(document).on("click", '#myonoffswitch18', function () {
		if (this.checked) {
			$('body').addClass('default');
			$('body').removeClass('boxed');
			localStorage.setItem("default", "True");
		} else {
			$('body').removeClass('default');
			localStorage.setItem("default", "false");
		}
	});
	$(document).on("click", '#myonoffswitch19', function () {
		if (this.checked) {
			$('body').addClass('boxed');
			$('body').removeClass('default');
			localStorage.setItem("boxed", "True");
		} else {
			$('body').removeClass('boxed');
			localStorage.setItem("boxed", "false");
		}
	});

	$(document).on("click", '#myonoffswitch55', function () {
		if (this.checked) {
			$('body')?.addClass('rtl');
			$('.main-body')?.addClass('rtl');
			$('body')?.removeClass('ltr');
			$('.main-body')?.removeClass('ltr');
			$("head link#style").attr("href", $(this));
			(document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.rtl.css"));
		} else {
			$('body')?.removeClass('rtl');
			$('.main-body')?.removeClass('rtl');
			$("head link#style").attr("href", $(this));
			(document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.css"));
		}
	});
	$(document).on("click", '#myonoffswitch54', function () {
		if (this.checked) {
			$('body')?.addClass('ltr');
			$('.main-body')?.addClass('ltr');
			$('body')?.removeClass('rtl');
			$('.main-body')?.removeClass('rtl');
			$("head link#style").attr("href", $(this));
			(document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.css"));
		} else {
			$('body').removeClass('ltr');
			$('.main-body').removeClass('ltr');
			$("head link#style").attr("href", $(this));
			(document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.rtl.css"));
		}
	});

});
$(document).on('click', "a[data-theme]", function () {
	$("head link#theme").attr("href", $(this).data("theme"));
	$(this).toggleClass('active').siblings().removeClass('active');
});


(function () {
	let bodyRtl = $('body').hasClass('rtl');
	if (bodyRtl) {
		$('body').addClass('rtl');
		$('.main-body').addClass('rtl');
		localStorage.setItem("rtl", "True");
		$("head link#style").attr("href", $(this));
		(document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.rtl.css"));
	} else {
		$('body').removeClass('rtl');
		$('.main-body').removeClass('rtl');
		localStorage.setItem("rtl", "false");
		$("head link#style").attr("href", $(this));
		(document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.css"));
	};
})();

